import React, { useState, useEffect } from 'react';
import { Button } from 'module-tsl-ui-elements';
import { FilterCategoryItem } from './FilterCategoryItem';
import { FilterAgeRange } from './FilterAgeRange';
import { loadCategory } from '../../../helpers/transform';

export const FilterCategory = ({ category, onChange }) => {
  const { name, qs, active } = category;
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const isAgeRange = qs === 'ageRange';

  const onClick = async () => {
    if (!subCategories.length > 0 && !isAgeRange) {
      setLoading(true);
      setSubCategories(await loadCategory(qs));
    }

    onChange(name, !active);
  };

  useEffect(() => {
    if (loading && subCategories.length > 0) {
      setLoading(false);
    }
  }, [subCategories]);

  return (
    <div className={active ? 'filters__category filters__category--expanded' : 'filters__category'}>
      <Button
        blockAlignedLeft
        isBlock
        theme="secondary"
        icon={loading ? '' : 'tds-chevron-down'}
        loading={loading}
        loadingFixedWidth={loading}
        iconRight
        onClick={onClick}
        size="lg"
      >
        {name}
      </Button>

      {!loading && active && (
        <>
          {isAgeRange && <FilterAgeRange />}
          <ul className="filters__category-list filters__category-list--parent">
            {subCategories.map((item) => {
              const { children } = item;

              return (
                <FilterCategoryItem key={item.queryStringId} item={item}>
                  {children && (
                    <ul className="filters__category-list filters__category-list--child">
                      {children.map((child) => (
                        <FilterCategoryItem key={child.queryStringId} item={child} />
                      ))}
                    </ul>
                  )}
                </FilterCategoryItem>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
};
